"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionTelemetrySerialization = void 0;
const ChargingTransactionChargingTelemetrySerialization_1 = require("./ChargingTransactionChargingTelemetrySerialization");
const ChargingTransactionLowRateChargingTelemetrySerialization_1 = require("./ChargingTransactionLowRateChargingTelemetrySerialization");
class ChargingTransactionTelemetrySerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.charging_details_telemetry = entity.charging_details_telemetry?.map((field) => field
            ? JSON.parse(ChargingTransactionChargingTelemetrySerialization_1.ChargingTransactionChargingTelemetrySerialization.serialize(field))
            : undefined);
        copy.low_rate_charging_details_telemetry =
            entity.low_rate_charging_details_telemetry?.map((field) => field
                ? JSON.parse(ChargingTransactionLowRateChargingTelemetrySerialization_1.ChargingTransactionLowRateChargingTelemetrySerialization.serialize(field))
                : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.charging_details_telemetry = entity.charging_details_telemetry?.map((field) => field
            ? ChargingTransactionChargingTelemetrySerialization_1.ChargingTransactionChargingTelemetrySerialization.deserialize(JSON.stringify(field))
            : undefined);
        copy.low_rate_charging_details_telemetry =
            entity.low_rate_charging_details_telemetry?.map((field) => field
                ? ChargingTransactionLowRateChargingTelemetrySerialization_1.ChargingTransactionLowRateChargingTelemetrySerialization.deserialize(JSON.stringify(field))
                : undefined);
        return copy;
    }
}
exports.ChargingTransactionTelemetrySerialization = ChargingTransactionTelemetrySerialization;
